var _templateObject = _taggedTemplateLiteralLoose(["\n      margin-top: ", ";\n      margin-bottom: ", ";\n      margin-left: ", ";\n      margin-right: ", ";\n  "], ["\n      margin-top: ", ";\n      margin-bottom: ", ";\n      margin-left: ", ";\n      margin-right: ", ";\n  "]);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import styled, { css } from "styled-components";
import { media } from "../../index";

var debug = false;

export var Outer = styled.div.withConfig({
    displayName: "atoms__Outer",
    componentId: "v2t1m8-0"
})(["box-sizing:border-box;display:flex;justify-content:center;background-color:", ";"], function (props) {
    return props.background ? props.theme.background : undefined;
});

export var Panel = styled.div.withConfig({
    displayName: "atoms__Panel",
    componentId: "v2t1m8-1"
})(["box-sizing:border-box;width:100%;max-width:", ";", " ", " ", " ", " ", " > div{margin-left:0;margin-right:0;}text-align:", ";", ""], function (_ref) {
    var theme = _ref.theme;
    return "" + theme.width;
}, media.phone(_templateObject, function (_ref2) {
    var mt = _ref2.mt;
    return mt[0];
}, function (_ref3) {
    var mb = _ref3.mb;
    return mb[0];
}, function (_ref4) {
    var theme = _ref4.theme;
    return theme.globalSitePadding[0] + "rem";
}, function (_ref5) {
    var theme = _ref5.theme;
    return theme.globalSitePadding[0] + "rem";
}), media.tablet(_templateObject, function (_ref6) {
    var mt = _ref6.mt;
    return mt[1];
}, function (_ref7) {
    var mb = _ref7.mb;
    return mb[1];
}, function (_ref8) {
    var theme = _ref8.theme;
    return theme.globalSitePadding[1] + "rem";
}, function (_ref9) {
    var theme = _ref9.theme;
    return theme.globalSitePadding[1] + "rem";
}), media.desktop(_templateObject, function (_ref10) {
    var mt = _ref10.mt;
    return mt[2];
}, function (_ref11) {
    var mb = _ref11.mb;
    return mb[2];
}, function (_ref12) {
    var theme = _ref12.theme;
    return theme.globalSitePadding[2] + "rem";
}, function (_ref13) {
    var theme = _ref13.theme;
    return theme.globalSitePadding[2] + "rem";
}), media.wide(_templateObject, function (_ref14) {
    var mt = _ref14.mt;
    return mt[3];
}, function (_ref15) {
    var mb = _ref15.mb;
    return mb[3];
}, function (_ref16) {
    var theme = _ref16.theme;
    return theme.globalSitePadding[3] + "rem";
}, function (_ref17) {
    var theme = _ref17.theme;
    return theme.globalSitePadding[3] + "rem";
}), Outer, function (props) {
    return props.align;
}, debug && "background-color: rgba(0,0,0,0.05);");